import {
  CHECK_LIST,
  CHECK_FILTER,
  CHECK_UPDATE,
  CONSIGNMENT_LIST,
  CONSIGNMENT_FILTER,
  CONSIGNMENT_UPDATE,
  CONSIGNMENT_UPDATE_SUCCESS,
  CONSIGNMENT_LIST_SUCCESS,
  CHECK_UPDATE_SUCCESS,
  CHECK_LIST_SUCCESS,
  PAYMENT_REQUEST_FAILED,
} from "store/payments/actionTypes";

const initialState = {
  checks: [],
  consignments: [],
  checkUpdated: {},
  consignmentUpdated: {},
  loading: false,
  error: "",
};

const payment = (state = initialState, action) => {
  switch (action.type) {
    case CHECK_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CHECK_FILTER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CHECK_UPDATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CONSIGNMENT_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CONSIGNMENT_FILTER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CONSIGNMENT_UPDATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CONSIGNMENT_LIST_SUCCESS:
      state = {
        ...state,
        loading: false,
        consignments: action.payload,
        consignmentUpdated: {},
        error: "",
      };
      break;
    case CONSIGNMENT_UPDATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        consignmentUpdated: action.payload,
        error: "",
      };
      break;
    case CHECK_LIST_SUCCESS:
      state = {
        ...state,
        loading: false,
        checks: action.payload,
        checkUpdated: {},
        error: "",
      };
      break;
    case CHECK_UPDATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        checkUpdated: action.payload,
        error: "",
      };
      break;
    case PAYMENT_REQUEST_FAILED:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default payment;
